import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ApiKeyInfoOutput } from '@digitalforest/ngx-oak-api';

export const ApiKeyInfoActions = createActionGroup({
  source: 'ApiKeyInfo',
  events: {
    Load: emptyProps(),
    LoadSuccess: props<{ apiKeyInfo: ApiKeyInfoOutput }>(),
    LoadFailure: props<{ error: unknown }>(),
    Unload: emptyProps(),
  },
});
